<div class="container-busqueda">
  <div class="blue"></div>
  <div class="busqueda">
    <h1 class="text-white text-md-center fw-semibold mx-3">
      Búsqueda de carpetas
    </h1>
    <h4 class="text-white text-md-center fw-semibold mx-3">
      Selecciona el criterio por el que deseas ubicar la carpeta
    </h4>
    <div class="pt-4">
      <app-tabs [tabs]="myTabs" [defaultTabIndex]="0">
        <!-- Busqueda por cedula -->
        <ng-template #cedulaTemplate>
          <div class="bg-blur p-5">
            <div class="search-form">
              <div class="form-field">
                <label for="cedula" class="form-label">Cédula</label>
                <input type="number" inputmode="numeric" class="form-control" placeholder="*número de cédula"
                  id="cedula" [(ngModel)]="entradabusqueda" autocomplete="off">
              </div>
              <div class="d-flex justify-content-center">
                <button-look-feel size="small" [compressed]="false" [loading]="searching"
                  [disabled]="searching||entradabusqueda==''" color="secondary" (click)="buscar('cedula')">
                  Buscar
                </button-look-feel>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Busqueda por fecha -->
        <ng-template #fechaTemplate>
          <div class="bg-blur p-5">
            <div class="search-form">
              <div class="form-field">
                <label for="fechaInicial" class="form-label">Fecha de inicio</label>
                <div class="input-group">
                  <input id="fechaInicial" class="form-control background-icon form-calendar"
                    placeholder="*Selecciona una fecha" autocomplete="off" [(ngModel)]="fechaInicial" ngbDatepicker
                    #fechaI="ngbDatepicker" [maxDate]="today" [minDate]="{ year: 1900, month: 1, day: 1 }"
                    (click)="fechaI.toggle()" [placement]="'bottom-start'">
                </div>
              </div>
              <div class="form-field">
                <label for="fechaFinal" class="form-label">Fecha de finalización</label>
                <div class="input-group">
                  <input id="fechaFinal" class="form-control background-icon form-calendar"
                    placeholder="*Selecciona una fecha" autocomplete="off" [(ngModel)]="fechaFinal" ngbDatepicker
                    #fechaF="ngbDatepicker" [minDate]="fechaInicial" [maxDate]="today"
                    [minDate]="{ year: 1900, month: 1, day: 1 }" (click)="fechaF.toggle()" [placement]="'bottom-start'">
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button-look-feel size="small" [compressed]="false" [loading]="searching"
                  [disabled]="searching || !fechaFinal || !fechaFinal" color="secondary" (click)="buscar('fecha')">
                  Buscar
                </button-look-feel>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Busqueda por pagaduria -->
        <ng-template #pagaduriaTemplate>
          <div class="bg-blur p-5">
            <div class="search-form">
              <div class="d-flex flex-column gap-2 mb-2">
                <h6 class="text-white fw-semibold">
                  Convenio
                </h6>
                <select (change)="getPagadurias(this.convenio)" class="form-select w-100"
                  aria-label="Default select example" [(ngModel)]="convenio" required style="width: 360px">
                  <option *ngFor="let item of filteredConvenio" [value]="item.codigo">
                    {{ item.nombre }}
                  </option>
                </select>
              </div>
              <div class="d-flex flex-column gap-2 mb-2">
                <h6 class="text-white fw-semibold">
                  Pagaduría
                </h6>
                <select class="form-select w-100" aria-label="Default select example" [(ngModel)]="pagaduria">
                  <option *ngFor="let item of filteredPagaduria" [value]="item.codigoPagaduria">
                    {{ item.nombre }}
                  </option>
                </select>
              </div>
              <div class="d-flex justify-content-center">
                <button-look-feel size="small" [compressed]="false" [loading]="searching" [disabled]="searching"
                  color="secondary" (click)="buscar('pagaduria')">
                  Buscar
                </button-look-feel>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Busqueda por apellido -->
        <ng-template #apellidoTemplate>
          <div class="bg-blur p-5">
            <div class="search-form">
              <div class="form-field">
                <label for="apellido" class="form-label">Apellido</label>
                <input type="text" class="form-control" placeholder="*Apellido" id="apellido"
                  [(ngModel)]="entradabusqueda" (ngModelChange)="entradabusqueda = $event.toUpperCase()"
                  autocomplete="off">
              </div>
              <div class="d-flex justify-content-center">
                <button-look-feel size="small" [compressed]="false" [loading]="searching"
                  [disabled]="searching||entradabusqueda==''" color="secondary" (click)="buscar('apellido')">
                  Buscar
                </button-look-feel>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Busqueda por carpeta -->
        <ng-template #carpetaTemplate>
          <div class="bg-blur p-5">
            <div class="search-form">
              <div class="form-field">
                <label for="numerocarpeta" class="form-label">Número de carpeta</label>
                <input type="number" inputmode="numeric" class="form-control" placeholder="*Número de carpeta"
                  id="numerocarpeta" [(ngModel)]="entradabusqueda" autocomplete="off">
              </div>
              <div class="d-flex justify-content-center">
                <button-look-feel size="small" [compressed]="false" [loading]="searching"
                  [disabled]="searching||entradabusqueda==''" color="secondary" (click)="buscar('numcarpeta')">
                  Buscar
                </button-look-feel>
              </div>
            </div>
          </div>
        </ng-template>
      </app-tabs>
    </div>
  </div>
</div>